import { Injectable } from "@angular/core";
import { FpOverviewData, SelectedFundsAmount } from "../../../organization/components/organization-overview/utils";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class FundsSelectorDropdownService {

  private fundsDataSubject = new BehaviorSubject<FpOverviewData>(new FpOverviewData());

  get fundsData(): BehaviorSubject<FpOverviewData> {
    return this.fundsDataSubject;
  }

  setFundsData(fundsData: FpOverviewData): void {
    this.fundsDataSubject.next(fundsData);
  }

  findSelected(selectedFundsAmount: SelectedFundsAmount): void {
    selectedFundsAmount.all = this.fundsData.value.all.filter((f) => f.isShown).length;
    selectedFundsAmount.spvs = this.fundsData.value.spvs.filter((f) => f.isShown).length;
    selectedFundsAmount.funds = this.fundsData.value.funds.filter((f) => f.isShown).length;
  }
}
